import {Component, OnInit} from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../../../services/admin.service';
import {SpecializationsService} from "../../services/specializations.service";
import {HttpStatus, ValidationRules, NO_POSITION, VALIDATION_PATTERN} from '../../constants/specializations.constants';

@Component({
  selector: 'app-edit-spec-group',
  templateUrl: './edit-spec-group.component.html',
  styleUrls: ['./edit-spec-group.component.css']
})
export class EditSpecGroupComponent implements OnInit {

  isEditBtnDisabled = true;
  specGroupName: string;
  operationSuccess = false;
  operationFail = false;
  notSelectedError = false;
  isLoaded = false;
  noPositions = false;
  getPositionsError = false;
  inProgress = false;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private adminService: AdminService,
    public specializationsServ: SpecializationsService
  ) {
  }

  groupInfo = {
    name: this.specializationsServ.nodeName
  };

  ngOnInit() {
    this.getPositions();
    this.specGroupName = this.specializationsServ.nodeName;
    this.groupInfo.name = this.specializationsServ.nodeName;
    this.checkInput(this.groupInfo.name);
  }

  checkInput(value) {
    this.specGroupName = value;
    if (value.trim() === '' || value.trim() === undefined || value.trim().length < ValidationRules.MIN_NAME_LENGTH || value.startsWith(' ') || value.endsWith(' ') || !VALIDATION_PATTERN.test(value)) {
      this.isEditBtnDisabled = true;
    } else {
      this.isEditBtnDisabled = false;
    }
  }

  closeAlert() {
    this.operationSuccess = false;
    this.operationFail = false;
  }

  checkPosition() {
    if (this.specializationsServ.nodePosition) {
      const positionName = this.specializationsServ.nodePosition;
      this.specializationsServ.positions.forEach(position => {
        if (position.name === positionName) {
          this.specializationsServ.selectedPositionId = position.id;
          this.specializationsServ.selectedPositionName = position.name;
        }
      });
    } else {
      this.selectPosition(NO_POSITION);
    }
  }

  getPositions() {
    if (this.specializationsServ.positions.length) {
      this.checkPosition();
      this.isLoaded = true;
      return;
    }
    this.fetchPositionsFromServer();
  }

  private fetchPositionsFromServer() {
    this.adminService.getActivePositions().subscribe(
      (res: any) => this.handlePositionsSuccess(res),
      (err) => this.handlePositionsError(err)
    );
  }

  private handlePositionsSuccess(res: any) {
    this.specializationsServ.positions = res.body;
    this.checkPosition();
    this.isLoaded = true;
    if (res.status === HttpStatus.NO_CONTENT) {
      this.noPositions = true;
    }
  }

  private handlePositionsError(err) {
    if (err.status === HttpStatus.INTERNAL_SERVER_ERROR || err.status === HttpStatus.NOT_IMPLEMENTED || err.status === HttpStatus.BAD_GATEWAY) {
      this.getPositionsError = true;
      this.isLoaded = true;
    }
  }

  selectPosition(position) {
    if (position === NO_POSITION) {
      this.specializationsServ.selectedPositionId = '';
      this.specializationsServ.selectedPositionName = NO_POSITION;
    } else {
      this.specializationsServ.selectedPositionId = position.id;
      this.specializationsServ.selectedPositionName = position.name;
    }
  }

  updateSpecGroup() {
    this.startOperation();
    const group = this.buildGroupObject();
    this.adminService.updateSpecGroup(group, this.specializationsServ.nodeId).subscribe(
      (response: any) => this.handleUpdateSuccess(response),
      (error) => this.handleUpdateError(error)
    );
  }

  private startOperation() {
    this.inProgress = true;
    this.specializationsServ.updateSpecGroupSuccess = false;
  }

  private buildGroupObject() {
    const group = {
      name: this.specGroupName,
      position: {
        id: this.specializationsServ.selectedPositionId,
        name: this.specializationsServ.selectedPositionName
      }
    };
    if (this.specializationsServ.selectedPositionName === NO_POSITION) {
      group.position = null;
    }
    return group;
  }

  private handleUpdateSuccess(response: any) {
    if (response.status === HttpStatus.OK) {
      this.specializationsServ.updateTree();
      this.specializationsServ.clearNodeSelection();
      this.operationSuccess = true;
      this.inProgress = false;
    }
  }

  private handleUpdateError(error) {
    if (error.status === HttpStatus.NOT_FOUND) {
      this.notSelectedError = true;
    }
    this.operationFail = true;
    this.operationSuccess = false;
    this.inProgress = false;
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/specializations/components/edit-spec-group/edit-spec-group.component.ts